import React from 'react'
import { Container, Row } from 'reactstrap'
import WeeklyTokens from './WeeklyTokens'


export default function TokenCount() {
  return (
    <>
      <Container fluid>
        <Row>
<WeeklyTokens/>
        </Row>
      </Container>
    </>
  )
}